
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M15.17 4.423C14.69 1.658 12.08-.187 9.344.3 6.61.786 4.3 2.915 4.783 5.676c.104.598.392 1.529.732 2.2L.549 15.042c-.184.264-.289.74-.233 1.06l.215 1.226c-.205-1.181.056.427.216.42l1.636.025c.316-.056.712-.323.886-.594l1.966-3.075.017-.02 1.716.135 2.297-3.6s.51-1.045 2.404-2.051c1.732-.802 3.184-.635 3.184-.635.421-1.054.531-2.298.318-3.51zM1.892 15.535l-.43.27.1-.486 4.663-6.672.322.226-4.655 6.662zm10.856-9.698c-.753 1.084-1.521.32-2.595-.441-1.073-.761-2.05-1.226-1.296-2.314a2.36 2.36 0 013.308-.59 2.42 2.42 0 01.583 3.345z"}}),_c('path',{attrs:{"d":"M19.793 14.502a5.245 5.245 0 11-10.49 0 5.245 5.245 0 0110.49 0zm-6.036-2.661c-.002.035 0 1.875 0 1.875H11.85c-.843.05-.828.786-.828.786s0 .741.828.786h1.908v1.875c.06.839.786.828.786.828s.745 0 .786-.828v-1.875h1.842c.828-.047.828-.786.828-.786s0-.734-.828-.786h-1.842v-1.875c-.044-.828-.786-.828-.786-.828s-.736 0-.786.828z"}})])])
          )
        }
      }
    